// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2IUHh","title":"Images45_title__13Zhw","images":"Images45_images__3T43F"};